import PageBody from './PageBody';

export default PageBody;
